import "./modules/common";
import vResize from "vue-resize-directive";
import VueApp from "~/Scripts/new/vueApp";
import PersonCard from "~/Components/People/PersonCard.vue";
import TimeLine from "~/Components/Timeline/TimeLine.vue";
import HeroCarousel from "~/Components/Base/HeroCarousel.vue";
import ImageFrame from "~/Components/Products/Tabs/ImageFrame.vue";

new VueApp( {
  name: "AboutUs",
  components: {
    PersonCard,
    TimeLine,
    HeroCarousel,
    ImageFrame,
  },
  directives: {
    resize: vResize,
  },
  data () {
    return {
      mainContentMinHeight: 0,
    };
  },
  methods: {
    /**
     * The main content part of the page has been resized.
     * The Quote in the main content uses position: aboslute, if the rest of the
     * main content is not large enought then it will result in the quote overlapping
     * other items on the page, in this case we have to force the height of the main content
     * to be at least the height of the quote
     */
    contentResize () {
      const { quote } = this.$refs;

      if ( quote ) {
        this.mainContentMinHeight = `${quote.clientHeight}px`;
      }
    },
  },
} );
